export default "__VITE_ASSET__282c40c9__"